import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { environment } from '../../../environments/environment';
import { MktEnvironmentService } from 'src/app/core/services/mkt-environment.service';
import { TransferState, makeStateKey } from '@angular/core';
import { OfferUtilService } from './offer-util.service';
import { CobrandingService } from "@citi-gcg-173875/citi-branding";

const PRICE_DETAILS_KEY = makeStateKey<any>('priceDetails');

@Injectable({
  providedIn: 'root'
})
export class PqpsUtilService {

  constructor(
    private mktEnvironmentService: MktEnvironmentService,
    private _transferState: TransferState,
    private _offerUtilService: OfferUtilService,
    private _cobrandingService: CobrandingService,


  ) { }
  public bannerIconsList=[];
  setBrandedAAImageBackground(imgPath:string){
    const timeoutInstance = setTimeout(() => {
      const element = document.querySelector('.branded-aa') as HTMLElement;
      if (element) {
        if(imgPath){
          element.classList.add('branded-aa-no-pp');
        }
        else {
          element.style.setProperty('background-image', 'none')
          element.style.setProperty('background-color', `#002D72`)
        }
      }
      clearTimeout(timeoutInstance);
    }, 500);
  }
  checkAndLoadBranding(oc: string) {
    let brandedAA = oc?.includes('-AA-');
    let brandedCostco = oc?.includes('-CO-');
    if (brandedAA) {
      this._cobrandingService.addCoBranding(true, {
        imgURL: "/CRD/images/aa-pqps/aadvantage.png",
        externalURL: "",
        altText: "American Airlines AAdvantage"
      });
    } else if (brandedCostco) {
      this._cobrandingService.addCoBranding(true, {
        imgURL: "/CRD/images/costco-pqps/costco.png",
        externalURL: "",
        altText: "Costco Wholesale"
      });
    }
    return (brandedAA || brandedCostco);
  }
  checkPQPS(currentCategories:any){
    if(currentCategories =='prescreen-offers' || currentCategories == 'prequal-offers' || currentCategories.includes('prequal-offers')){
      return true;
    }
    return false;
  }
  checkPQ(currentCategories:any){
    if( currentCategories == 'prequal-offers' || currentCategories.includes('prequal-offers')){
      return true;
    }
    return false;
  }
  filterCardPQPSCategories(pidList:string[],cardListContent:any,sortCards:boolean){
     // pidList = ['142']; // Double cash
     // pidList = ['257']; // Diamond prefered
    let displayCards:any;
    if(sortCards){
      // This will return sorted card-list [from TotalCards(Mktg)] that matches with PID list which is in sorted order [from PQPS].
      displayCards=  cardListContent.filter(card => pidList.includes(card['pid']))
                                    .sort((a,b) =>{
                                      return pidList.indexOf(a['pid']) - pidList.indexOf(b['pid'])
                                    })
                                    .map(item =>item['internalCardName']);
    } else {
      // This will return card-list [from TotalCards(Mktg)] that matches with PID list [from PQPS].

      displayCards=  cardListContent.filter(card => pidList.includes(card['pid']))
                                    .map(item =>item['internalCardName']);
    }

    return displayCards
  }
  getPQPSApplyNowUrl(hashCode:string,offerHashKey:string,activityType:string,invitationNumber?:string, pidId?:string,aoOfferParams?:string,oc?: string,offerDataHash?:string){
    let hostname = this.mktEnvironmentService.getEnvironmentVar('PRE_QUAL_URL');//environment.PRE_QUAL_URL;
    hostname = hostname.replace('UNSOL','PREAPP');
    if(activityType?.toUpperCase()==='MBOL_ECM_PRESCREEN' || activityType?.toUpperCase()==='MBOL_ECM_PREQUAL')
      return `${hostname}&HKOP=${hashCode}&offerHashKey=${offerHashKey}&status=Redirect2Mbol&acquisitionType=${activityType}&invitationNumber=${invitationNumber}&pid=${pidId}&offerDataHash=${offerDataHash}`
    else {
        let url;
        if (aoOfferParams) {
          url = `${hostname}&HKOP=${hashCode}&offerHashKey=${offerHashKey}&acquisitionType=${activityType}&aoOfferParams=${aoOfferParams}`;
        } else {
          url = `${hostname}&HKOP=${hashCode}&offerHashKey=${offerHashKey}&acquisitionType=${activityType}`;
        }
        
        if (oc) {
          url += `&OC=${oc}`;
        }
        
        return url;
      }
  }
  updatePricingValuesPQPS(pid: number, elementRef: ElementRef, renderer2: Renderer2,acquisitionType:string, oc?: string) {

    const instance = setInterval(() => {
      const priceDetails = this._transferState.get(PRICE_DETAILS_KEY, []);
      if (priceDetails.length === 0) return;
      clearInterval(instance);
      if(!!pid){
      const dynamicPrice = priceDetails.filter(({ productIdentifier }) => pid == productIdentifier)[0];
      if (!!dynamicPrice) this.setPriceForEachCard(dynamicPrice, elementRef, renderer2,acquisitionType, oc);
      } else {
        priceDetails.map(async dynamicPrice => await this.setPriceForEachCard(dynamicPrice, elementRef, renderer2,acquisitionType,oc))
      }
    }, 500);

  }

  private setPriceForEachCard(dynamicPrice: any, elementRef: ElementRef<any>, renderer2: Renderer2,acquisitionType:string, oc?: string) {
    let termsUrl = dynamicPrice['terms-link'].replace('UNSOL', 'PREAPP') + 
                 `&acquisitionType=${acquisitionType}${acquisitionType?.toUpperCase() === 'ITA' ? `&OC=${oc}` : ''}`;
                           
    let dynamicUrls = {
    'applyNowUrl': dynamicPrice['apply-now-button'],
    'mbolApplyNowUrl': dynamicPrice['mbol-apply-now-button'],
    'termsUrl': termsUrl,
     };            
    this._offerUtilService.injectDynamicText(elementRef, renderer2, dynamicPrice, dynamicPrice.productIdentifier);
    this._offerUtilService.injectDynamicUrls(elementRef, renderer2, dynamicUrls, dynamicPrice.productIdentifier);
  }
  getHKOPFromPID(pidList, hkopList, currentPID){
    return hkopList[pidList.indexOf(currentPID)];
  }
  setRibbonShowHide(pidList:string[], pid:string, currentCategories:any){
    if(currentCategories.includes('prequal-offers') || currentCategories =='prescreen-offers' )
      return pidList.indexOf(pid)>-1 ;
    }

    getDynamicConstAppr(pidList, oc){
      let dynamic_cont_appr: string;
      const isBranded = this.checkAndLoadBranding(oc);
      this.bannerIconsList.forEach((icon,index) =>{
       if(window.location.pathname.toString()=== ("/credit-cards/compare/"+this.bannerIconsList[index]['contentId']).toString()){
        dynamic_cont_appr = this.bannerIconsList[index]['title'];
       }
     });
       if(pidList?.length < 2 || isBranded){
        dynamic_cont_appr = "Without Tabs"
        }
                return dynamic_cont_appr;
    }

    getEvent(currentCategories){
      let event:string;
      event = currentCategories.includes('prequal-offers')
        ? "product_view|cards_prequal_complete"
        : "product_view";
      return event;
      }
}
